<template>
  <b-modal
    id="modal-auditoria"
		title="Auditoria"
		centered
		size="lg"
		:hide-footer="true"
    @shown="getAudits"
  >
    <div class="row" v-if="loading">
			<span class="col-12 text-center">Aguarde</span>
			<load mode="table" />
		</div>
    <div v-else class="card card-body p-2 border rounded overflow-auto" style="max-height: 400px;">
      <b-table 
        empty-text="Nenhum registro encontrado"
        :items="auditorias"
        striped
        hover
        show-empty
        small
        outlined
        stacked="lg"
        table-class="mb-3"
        :fields="[
          { key: 'tecnico', label: $t('Técnico') },
          { key: 'created_at_formatado', label: $t('Data de atualização') },
          { key: 'campos', label: $t('Campos alterados') },
        ]"
      >
        <template v-slot:cell(campos)="data">
          <div v-for="(itens, index) in formatDados(data.item.new_values)" :key="index">
            <span v-if="index != 'updated_at' && index != 'editado'"> {{ formatIndex(index) }} </span>
          </div>
        </template>
      </b-table>
    </div>
  </b-modal>
</template>

<script>

export default {
  props: ['servico','servico_id'],
  data() {
    return { 
      item: null,
      loading: true,
      auditorias: []
    }
  },
  methods: {
    formatIndex(index) {
      if(index == 'user') return 'Técnico Responsável';
      else if(index == 'recursos_mobilizados') return 'objetivos';

      index = index.replaceAll('_id_', '_');
      index = index.replace(/_id\b/g, '');
      return index;
    },
    formatDados(values){
      try {
        return JSON.parse(values);
      } catch (e) {
        return values;
      }
    },
    abrirModal(data){
      this.item = data;
      this.$bvModal.show('modal-auditoria-dados')
    },
    getAudits(){
      axios.get(`api/dashboard/${this.servico}/auditorias/${this.servico_id}`)
      .then((response) => {
        this.auditorias = response.data;
        this.loading = false;
      })
      .catch((error) => {
        swal.fire({
          title: "Ops!",
          html: "O item não foi carregado corretamente<br>" + error,
          icon: "error",
        });
      })
      .finally(() => {
        this.loading = false;
      })
    }
  }
}
</script>